module.exports = __webpack_public_path__ + "img/qrcode-icon.0d952f9c.jpg";